import dayjs from 'dayjs';
import { EXPIRATION_DAYS_THRESHOLD } from '../common/constants';
import EntityMapper from '../models/EntityMapper';
import { SearchImpressionDescriptor } from '../models/Analytics';
import { VenngoPerk, PerkSource } from './Perk';

export default class ESPerkMapper implements EntityMapper<any, VenngoPerk> {
  // private language = currentLanguage();
  private language = window.l.locale;
  private localizedStringFields = [
    'title',
    'tagline',
    'description',
    'articleBody',
    'logo',
    'mobile',
    'banner',
    'thumbnail',
  ];
  private localizedStringArrayFields = ['caption', 'tip', 'feature', 'keywords', 'image'];

  constructor(public impressionDescriptor?: SearchImpressionDescriptor) {}

  map = (data: any): VenngoPerk => {
    const perk = data._source;
    this.mapLocalizedStringFields(perk);
    this.mapLocalizedStringArrayFields(perk);
    perk.source = PerkSource.Venngo;

    perk.isExpiring = perk.dateOfferEnd
      ? dayjs(perk.dateOfferEnd).subtract(EXPIRATION_DAYS_THRESHOLD, 'day').isBefore(new Date())
      : false;

    // TODO: (Rating) should come from API.
    // perk.rating = random(0, 5);
    perk.rating = 3;

    perk.locations = perk.location;
    console.log("DO I EVEN GET HERE");
    if (this.impressionDescriptor) {
      console.log("I EVER GET TRIGGERED");
      if (this.impressionDescriptor.templateId) perk.templateId = this.impressionDescriptor.templateId;
      if (this.impressionDescriptor.query) perk.searchQuery = this.impressionDescriptor.query;
    }

    delete perk.location;
    return perk;
  };

  mapLocalizedStringFields(data: any) {
    for (const field of this.localizedStringFields) {
      data[field] = data[field][this.language];
    }
  }

  mapLocalizedStringArrayFields(data: any) {
    for (const field of this.localizedStringArrayFields) {
      data[field] = data[field][this.language];
    }
  }
}
